<template>
  <div class="avatar">
    <Crown class="crown" v-if="crown" />
    <figure>
      <img class="avatar-img" :src="image" width="65" height="65" alt="" />
      <img
        v-if="gus"
        class="gus"
        src="@/assets/gus.gif"
        alt="a blue parrotlet named Gus"
      />
    </figure>
    <header>
      <h1>{{ name }}</h1>
      <h2>{{ title }}</h2>
    </header>
  </div>
</template>

<script setup>
import Crown from "@/components/Crown.vue";

const props = defineProps({
  name: { type: String, required: true },
  title: { type: String },
  image: { type: String, default: "" },
  crown: { type: Boolean, default: false },
  gus: { type: Boolean, default: false },
});
</script>

<style scoped lang="scss">
.avatar {
  display: flex;
  align-items: center;
  position: relative;
  margin: 15px 0;
}

.crown {
  position: absolute;
  top: -1.6em;
  left: 0.25em;
  opacity: 0;
  animation:
    0.12s ease-in-out forwards inaugurate,
    10s infinite 0.12s jaunty;
  transform-origin: center bottom;

  // we could fiddle with the size if we wanted
  @media (max-width: 35em) {
    position: absolute;
    left: -0.15em;
  }
}

/* coronate the winner */
@keyframes inaugurate {
  0% {
    opacity: 0;
    transform: scale(0.8) translate(-0.4em, -2em) rotate(-12deg);
  }

  50% {
    opacity: 1;
    transform: translate(0, -0.2em) rotate(0);
  }

  100% {
    transform: rotate(-24deg);
    opacity: 1;
  }
}

/* preen */
@keyframes jaunty {
  0% {
    transform: rotate(-24deg);
  }

  89% {
    transform: rotate(-24deg);
  }

  90% {
    transform: rotate(-12deg);
  }

  97% {
    transform: rotate(-12deg);
  }

  99% {
    transform: rotate(-32deg);
  }

  100% {
    transform: rotate(-24deg);
  }
}

figure {
  position: relative;
  margin: 0;
}

img.avatar-img {
  border-radius: 50%;
  margin-right: 0.9em;
  flex-shrink: 0;

  @media (max-width: 35em) {
    height: 40px;
    width: 40px;
  }
}

img.gus {
  position: absolute;
  width: 35%;
  left: 15%;
  top: 40%;
}

h1 {
  margin: 0;
  font-size: 1em;

  @media (max-width: 35em) {
    font-size: 0.823em;
  }
}

h2 {
  margin: 0;
  font-size: 1em;
  font-weight: normal;

  @media (max-width: 35em) {
    font-size: 0.823em;
  }
}
</style>
